<template>
  <div>
    <center>
      <h1>Incident Details</h1>
      <p>Incident Details</p>
    </center>
    <hr>
  <v-btn @click="goBack()" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
  <div class="incidentDetails">
    <div id="incidentType" class="margin-top">
      <h4>Incident Type</h4>
      <h3>{{ incidentDetails.type }}</h3>
    </div>
    <hr>
    <div id="location" class="margin-top pSquash">
      <h4>Location</h4>
      <a :href="'https://maps.google.com/?q='+urlAddress" target="_blank">{{ incidentDetails.address }}</a>
      <p>{{ incidentDetails.municipality }}</p>
      <br v-if="incidentDetails.cross_street">
      <p v-if="incidentDetails.cross_street">{{incidentDetails.cross_street}}</p>
    </div>
    <hr>
    <div id="time" class="margin-top pSquash">
      <h4>Time and Date</h4>
      <p>{{ incidentDetails.time_created }}</p>
      <p>{{ incidentDetails.date_created }}</p>
    </div>
    <hr>
    <div id="units" class="margin-top pSquash">
      <h4>Units Assigned</h4
      >
      <div class="unitsIndividual" v-for="unit in incidentDetails.units" v-bind:key="unit.id" @click="unitClick(unit.id)">
        <p>{{unit.unit_name}}</p>
      </div>
    </div>
    <hr>
    <div v-if="commentsLenght" id="incidentInfo" class="margin-top pSquash">
      <h4>Other Incident Info</h4>
      <div id="incidentInfoInvididual" v-for="comment in incidentDetails.comments" v-bind:key="comment.comment">
        <p>{{comment.comment}}</p>
      </div>
      <hr>
    </div>
  </div>
    <v-dialog v-model="UnitDetailsBox" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Unit Details - {{unit.unit_name}}
          </v-card-title>
  
          <v-card-text>
            Time added to incident: {{unit.time_added_to_incident}}
            <br>
            <br>
            Department: {{unit.department}}
            <br>
            Department ID: {{unit.department_number}}
            <br>
            Service Type: {{unit.department_service}}
            <br>
            <br>
            Other Notes: {{unit.unit_notes}}
          </v-card-text>
  
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="UnitDetailsBox = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    incidentDetails: [],
    commentsLenght: 0,
    UnitDetailsBox: false,
    openedFromNotification: false,
    unit: {},
    urlAddress: null,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    
    window.scrollTo(0,0);

    if (!this.$route.query.incidentID){
      this.error("Could not find incidentID query string. Please try again...");
      return
    }
    const incidentID = this.$route.query.incidentID
    this.getIncidentData(incidentID)
    if (this.$route.query.notification){
      this.openedFromNotification = true;
    }
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    goBack(){
      if (this.openedFromNotification){
        this.$router.push({path: 'watchlist'});
      } else{
        history.back();
      }
    },
    async getIncidentData(incidentID){
      const response = await fetch(localStorage.apiURL + "/app/incident/" + incidentID, {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      });

      if (!response.ok){
        if (response.status == 404){
          this.error("Incident not found");
          return
        }
        this.error("api returned " + response.status);
        return
      }

      let data = await response.json();

      if (!data.success){
        this.error(data.msg);
        return
      }
      
      this.incidentDetails = data.details;
      this.commentsLenght = this.incidentDetails.comments.length;
      this.urlAddress = encodeURIComponent(this.incidentDetails.full_address);
    },
    unitClick(id){
      this.unit = this.incidentDetails.units[id];
      this.UnitDetailsBox = true;
    }
  },
};
</script>

<style scoped>
.incidentDetails{
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 100px;
}
.margin-top{
  margin-top: 50px;
}
.pSquash p{
  margin: 0;
}

.unitsIndividual p{
  color: blue;
}
</style>
